import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, Injector } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { AppLoginPrincipalService, CatalogService, Pagination, PermissionTemplateService, StoreContainerModel, StoreService } from 'blg-akaun-ts-lib';
import * as moment from 'moment';
import { PermWizardSelectors } from '../../../../../../../modules/permission/permission-wizard-controller/selectors';
import { AppConfig } from '../../../../../../../visa';
import { Observable, of } from 'rxjs';
import { map, pluck, exhaustMap } from 'rxjs/operators';
import { SubSink } from 'subsink2';
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-main-details",
  templateUrl: "./main-details.component.html",
  styleUrls: ["./main-details.component.scss"],
})
export class MainDetailsComponent implements OnInit, OnDestroy {
  @Input() editMode: boolean;
  @Output() updateMain = new EventEmitter<FormGroup>();
  @Output() onDeleteTrigger = new EventEmitter();
  // @Input() appletSettings$: Observable<AppletSettings>;

  protected subs = new SubSink();

  apiVisa = AppConfig.apiVisa;
  masterVisa = AppConfig.masterVisa;

  // fields that require options
  status: string;
  statusArr: any = [];
  newStatusArr: any = [];

  stores: StoreContainerModel[] = [];
  pagination = new Pagination();

  // this is the form group
  public form: FormGroup;

  //translation variable
  code_text: string;
  name_text: string;
  type_text: string;
  status_text: string;
  description_text: string;
  created_by_text: string;
  updated_by_text: string;
  created_date_text: string;
  updated_date_text: string;
  active_text: string;
  inactive_text: string;
  not_a_valid_entry_text: string;
  delete_button: string;

  constructor(
    protected readonly store: Store,
    private storeService: StoreService,
    private permTemplateService: PermissionTemplateService,
    private catalogueService: CatalogService,
    private appLoginPrincipalService: AppLoginPrincipalService,
    private injector: Injector) {
    const translateService = this.injector.get(TranslateService, null);
    if (translateService) {
      translateService.get('labels').subscribe(res => {
        this.code_text = res.code;
        this.name_text = res.name;
        this.type_text = res.type;
        this.status_text = res.status;
        this.description_text = res.description;
        this.created_by_text = res.created_by;
        this.updated_by_text = res.updated_by;
        this.created_date_text = res.created_date;
        this.updated_date_text = res.updated_date;
        this.active_text = res.active;
        this.inactive_text = res.inactive;
        this.not_a_valid_entry_text = res.invalid_entry;
        this.delete_button = res.delete_button_nocaps;
      });
    } else {
      // Fallback if translation service is unavailable
      this.code_text = 'Code';
      this.name_text = 'Name';
      this.type_text = 'Type';
      this.status_text = 'Status';
      this.description_text = 'Description';
      this.created_by_text = 'Created By';
      this.updated_by_text = 'Updated By';
      this.created_date_text = 'Created Date';
      this.updated_date_text = 'Updated Date';
      this.active_text = 'ACTIVE';
      this.inactive_text = 'INACTIVE';
      this.not_a_valid_entry_text = 'Not a valid entry';
      this.delete_button = 'Delete';
    }
  }

  ngOnInit() {
    this.statusArr = [
      { value: 'ACTIVE', viewValue: this.active_text },  // Use the translated value
      { value: 'INACTIVE', viewValue: this.inactive_text }  // Use the translated value
    ];
    // this is for the store dropdown
    this.subs.sink = this.storeService.get(this.apiVisa).pipe(
      pluck('data')
    ).subscribe(
      response => this.stores = response
    )

    this.form = new FormGroup({
        code: new FormControl(''),
        name: new FormControl(''),
        type: new FormControl(''),
        currStatus: new FormControl(''),
        status:new FormControl("ACTIVE",),
        description: new FormControl(''),
        createdBy: new FormControl(''),
        updatedBy: new FormControl(''),
        createdDate: new FormControl(''),
        updatedDate: new FormControl(''),
    });
    const permWizard$ = this.store.select(PermWizardSelectors.selectPermWizard);

    this.newStatusArr = this.statusArr;

    this.updateMain.emit(this.form);
    this.subs.sink = permWizard$
    .subscribe(permWizard => {
      //this.selectedPermWizard = permWizard;

      // patch form values
      this.subs.sink = this.getPermTemplate(permWizard.app_perm_template_hdr.guid.toString()).pipe(
        exhaustMap(resolve => {
          console.log(resolve)
          this.pagination.conditionalCriteria = [
            {
              columnName: "subject_guid",
              operator: "=",
              value: resolve.app_perm_template_hdr.created_by_subject_guid.toString(),
            },
            {
             columnName: "principal_type",
             operator: "=",
             value: "EMAIL_USERNAME",
            }
          ];
          if(resolve.app_perm_template_hdr.created_by_subject_guid){
            return this.appLoginPrincipalService.getByCriteria(this.pagination, this.apiVisa).pipe(
              map(response => Object.assign({
                ...resolve,
                createdBy: response.data[0].app_login_principal.principal_id
              }))
            )
          }
          else{
            return of(resolve)
          }
        }),
        exhaustMap(resolve => {
          this.pagination.conditionalCriteria = [
            {
              columnName: "subject_guid",
              operator: "=",
              value: resolve.app_perm_template_hdr.updated_by_subject_guid?.toString(),
            },
            {
             columnName: "principal_type",
             operator: "=",
             value: "EMAIL_USERNAME",
            }
          ];
          if(resolve.app_perm_template_hdr.updated_by_subject_guid){
            return this.appLoginPrincipalService.getByCriteria(this.pagination, this.apiVisa).pipe(
              map(response => Object.assign({
                ...resolve,
                updatedBy: response.data[0].app_login_principal.principal_id
              }))
            )
          } else{
            return of(resolve)
          }
        }),
      )
      .subscribe(permWizard => {
        console.log(permWizard)
        this.form.patchValue({
          code: permWizard.app_perm_template_hdr.code,
          name: permWizard.app_perm_template_hdr.name,
          type: permWizard.app_perm_template_hdr.type,
          status: permWizard.app_perm_template_hdr.status,
          description: permWizard.app_perm_template_hdr.description,
          createdBy: permWizard.createdBy,
          updatedBy: permWizard.updatedBy,
          createdDate: moment(permWizard.app_perm_template_hdr?.created_date).format("YYYY-MM-DD, HH:mm:ss"),
          updatedDate: moment(permWizard.app_perm_template_hdr?.updated_date).format("YYYY-MM-DD, HH:mm:ss"),

        })
      })
    })

  }
  getPermTemplate(permTemplateGuid: string) {
    return this.permTemplateService.getByGuid(permTemplateGuid, this.masterVisa)
      .pipe(
        map(x => x.data)
      );
  }

  onDelete() {

  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
